import { __rest } from "tslib";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { omit } from 'lodash';
import { useCallback, useRef } from 'react';
import { styled } from 'styled-components';
import { AttachedFile } from "../../attached-file/src";
import { Box } from "../../box/src";
import { s__ } from "../../i18n/src";
import { FakeLink } from "../../link/src";
import { BaseInput } from './BaseInput';
const UploadInput = ({ disabled, handleClick, instructions, uploadText, }) => disabled ? (_jsx(Box, { font: "body-regular-dove", pb: 1, children: s__('UploadInput|You do not have the permission to edit this file.') })) : (_jsxs(_Fragment, { children: [instructions && (_jsx(Box, { font: "body-regular-dove", pb: 1, children: instructions })), _jsx(FakeLink, { onClick: handleClick, tabIndex: 0, children: uploadText || s__('UploadInput|Upload file') })] }));
const InputComponent = (_a) => {
    var _b, _c;
    var { customFileName, dataTestId, disabled, formats, instructions, name, onChange, uploadText, value } = _a, props = __rest(_a, ["customFileName", "dataTestId", "disabled", "formats", "instructions", "name", "onChange", "uploadText", "value"]);
    const ref = useRef(null);
    const handleChange = useCallback((onChangeEvent) => {
        var _a;
        onChange((_a = onChangeEvent.target.files) === null || _a === void 0 ? void 0 : _a[0]);
    }, [onChange]);
    const handleRemoveAttachment = useCallback(() => {
        onChange(null);
        if (ref.current) {
            ref.current.value = '';
        }
    }, [onChange]);
    const handleClick = useCallback(() => { var _a; return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.click(); }, []);
    const fileName = (_c = (_b = value === null || value === void 0 ? void 0 : value.name) !== null && _b !== void 0 ? _b : value === null || value === void 0 ? void 0 : value.asset_private_file_name) !== null && _c !== void 0 ? _c : customFileName;
    const inputProps = omit(props, 'required');
    return (_jsxs(Box, { flexDirection: "column", children: [value ? (_jsx(AttachedFile, { customAriaLabelRemove: s__('FileInput|Remove %{label}').i__({
                    label: fileName,
                }), disabled: disabled, file: { name: fileName }, onRemove: handleRemoveAttachment })) : (_jsx(UploadInput, { disabled: disabled, handleClick: handleClick, instructions: instructions, uploadText: uploadText })), _jsx(StyledInput, Object.assign({}, inputProps, { accept: Array.isArray(formats) ? formats.join(',') : formats, "aria-hidden": true, "data-testid": dataTestId, hidden: true, name: name, onChange: handleChange, ref: ref, type: "file" }))] }));
};
export const FileInput = (_a) => {
    var { customFileName = '', formats, instructions, uploadText, variant = 'normal' } = _a, props = __rest(_a, ["customFileName", "formats", "instructions", "uploadText", "variant"]);
    return (_jsx(BaseInput, Object.assign({}, props, { inputComponent: InputComponent, inputProps: { customFileName, formats, instructions, uploadText }, variant: variant })));
};
const StyledInput = styled.input `
  visibility: hidden;
  position: absolute;
  top: 0;
  // To avoid zoom on iOS mobile devices, inputs must have font-size set to 16px (font-size is not really used here, no need to scope to only s & m)
  font-size: ${({ theme }) => theme.fontSizes[3]} !important;
`;
//# sourceMappingURL=FileInput.js.map